import axios from 'axios'
import tool from '../Tools'

var startTime = null
var commentList = []
var sendMsgCallBack = null
var timer = null
var commentTime = 1 // 评论后置时间

function setCommentCallback (callBack) {
  sendMsgCallBack = callBack
}

function startCommentRun () {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
  timer = setInterval(() => {
    if (commentList.length == 0) {
      return
    }
    const tmpTime = new Date(startTime).valueOf()
    const comment = commentList[0]
    if (
      parseInt(comment.send_time) * 1000 + tmpTime + commentTime * 1000 <
      new Date().valueOf()
    ) {
      // 需要发送消息
      if (sendMsgCallBack) {
        const item = {
          module: 'text_comment',
          content: comment.content,
          nick: comment.nick,
          header: comment.header
        }
        commentList.shift()
        // console.log(commentList);
        sendMsgCallBack(item)
      }
    }
  }, 50)
}

function startLoad (start_time, tid, callBack) {
  startTime = start_time
  t_id = tid
  const tmpTime = new Date(start_time).valueOf()
  const option = 'tid=' + tid + '&page_num=' + 10000
  axios
    .post(tool.baseUrl2() + '/api/fakeLive/getCommentList', option)
    .then(function (res) {
      if (res.data.code == 200) {
        let list = res.data.data.list
        list.sort((a, b) => {
          if (a.send_time == b.send_time) {
            return a.create_time - b.create_time
          } else {
            return a.send_time - b.send_time
          }
        })
        // 删除当前时间已经评论过
        const index = list.findIndex((item) => {
          return (
            tmpTime + parseInt(item.send_time * 1000) > new Date().valueOf()
          )
        })
        if (index != -1) {
          list.splice(0, index)
        } else {
          list = []
        }
        commentList = list
        totalCount = res.data.data.total_count
        if (callBack) {
          callBack(true)
        }
      } else {
        if (callBack) {
          callBack(false)
        }
        console.error('获取评论失败:', res)
      }
    })
    .catch(function (error) {
      if (callBack) {
        callBack(false)
      }
      console.error('获取评论失败:', error)
    })
}

export default {
  setCommentCallback,
  startCommentRun,
  startLoad
}



// WEBPACK FOOTER //
// ./src/kits/im/FakeIm.js